import axios from "axios";

export const getInventoryByProductId = async (
  token,
  branch,
  productId,
  batch
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_COLLEGE_ERP_API}inventory-productId`,
      {
        params: {
          branch,
          productId,
          batch, // ✅ added batch as param
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching inventory:", error);
    throw error;
  }
};
